export class EmdEmployee {
    displayName: string;
    firstName: string;
    lastName: string;
    email: string;
    ntAccount: string;
    badgeId: number | null;
    badgeRfid: string | null;

    constructor(data: any = {}) {
        this.displayName = data.displayName || '';
        this.firstName = data.firstName || '';
        this.lastName = data.lastName || '';
        this.email = data.email || '';
        this.ntAccount = data.ntAccount || '';
        this.badgeId = data.badgeId ?? null;
        this.badgeRfid = data.badgeRfid ?? null;
    }
}
